// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_B","tabbox":"_C","tabBar":"_D","tabBar__tabBaritem":"_E","tabBar__tabBaritemAction":"_F"};